import HTTP from '@/components/general/http/http'

import config from '@/config/env'

export default {
  getSDAsInfo(data) {

    let url = config.api.baseUrl + '/api/sdasInfo' + data

    return HTTP
      .request()
      .get(url)
      .then(response => response)
      .catch(error => error)

  },
  migrateCSVFile(data) {

    let url = config.api.baseUrl + '/api/sdasInfo/migrate'

    return HTTP
      .request()
      .post(url, data)
      .then(response => response)
      .catch(error => error)

  }
}



// WEBPACK FOOTER //
// ./src/api/sdas-info.js